<ng-container
  *ngIf="{
    step: featureTourService.featureTourStepBS | async
  } as condition">
  <ng-container *ngIf="condition.step === FeatureTourStepEnum.MASS_ACTIONS">
    <div class="feature-tour-pseudo-mass-actions" [class.highlight]="popoverDisplayed">
      <div>
        <button mat-raised-button translate="cancel"></button>
        <span translate="search/feature-tour/mass-actions/messages-selected"></span>&nbsp;
        <span class="pseudo-link" translate="search/feature-tour/mass-actions/select-all"></span>
      </div>
      <div cdkOverlayOrigin #trigger>
        <button mat-raised-button translate="archive"></button>
        <button mat-raised-button translate="export"></button>
        <mat-checkbox [checked]="true"></mat-checkbox>
      </div>
    </div>
    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayOrigin]="trigger"
      [cdkConnectedOverlayOpen]="popoverDisplayed"
      [cdkConnectedOverlayPush]="true"
      [cdkConnectedOverlayOffsetX]="0"
      [cdkConnectedOverlayOffsetY]="0">
      <div class="feature-tour-step-container">
        <app-step-popover
          [titleKey]="'search/feature-tour/mass-actions/title'"
          [descriptionKey]="'search/feature-tour/mass-actions/description'"
          [nextKey]="'search/feature-tour/mass-actions/let-s-go'"
          [previousKey]="'search/feature-tour/previous'"
          (closeStep)="featureTourService.setFeatureStep(null)"
          (next)="featureTourService.setFeatureStep(null)"
          (previous)="featureTourService.setFeatureStep(FeatureTourStepEnum.ADVANCED_SEARCH)"></app-step-popover>
      </div>
    </ng-template>
  </ng-container>
</ng-container>
